import {Emitter} from "./emitter";

export class SubscriptionQuantitySelector extends Emitter {
    constructor(selector) {
        super();
        this.selector = $(selector);
        this.input = $(selector.find('input[type="number"]'));
        this.baseQty = this.selector.data('base-product-qty');
        this.handleStepClick = this.handleStepClick.bind(this);
        selector.on('click', '.step-button', this.handleStepClick);
    }

    handleStepClick(e) {
        const {selector, input} = this,
           downButton = selector.find('.step-button.down'),
            button = $(e.target),
            qtyMin = -Math.abs(this.baseQty),
            qtyPlus = this.baseQty,
            delta = button.hasClass('up') ? qtyPlus : qtyMin,
            variantId = selector.parent().data('variant-id'),
            newValue = Math.max(1, parseInt(input.val(), 10) + delta);
        input.val(newValue);
        downButton.prop('disabled', newValue === this.baseQty);
        this.emit('subqtychange', newValue, variantId);

        e.preventDefault();
        e.stopPropagation();
    }
}